// src/components/UnauthorizedPage.js

import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function UnauthorizedPage() {
  const navigate = useNavigate();

  const handleReturnToLogin = () => {
    navigate('/login');
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        textAlign="center"
      >
        <Box
          sx={{
            bgcolor: 'grey.100', // Light grey background
            border: 1,
            borderColor: 'grey.300', // Border color
            padding: 3,
            borderRadius: 1,
            marginBottom: 2, // Add space between box and button
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            Oh no, you are not authorized to access this app.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Please reach out to Jamatar on Discord if you feel this is an error.
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={handleReturnToLogin}
        >
          Return to Login Page
        </Button>
      </Box>
    </Container>
  );
}

export default UnauthorizedPage;
